import { Pipe, PipeTransform } from "@angular/core";

/**
 * Filtro responsável por cortar um texto de acordo com o
 * tamanho recebido por parâmetro, e adicionar reticências
 * no final.
 */
@Pipe({
    name: "cutString"
})
export class CutStringPipe implements PipeTransform {

    transform(input: string, maxChars: number): string {
        if (input && input.split("").length > maxChars) {
            return input.substring(0, maxChars) + "...";
        }

        return input;
    }
}
